module.exports = __webpack_public_path__ + "static/angela-e1f28d001dad731c04d287daf4579a7c.jpg";